import PaymentOptions from './paymentOptionsDayTour.js'
import {PaymentTab} from "../../../defaultFlow/index.js"
import paymentTabSchema from '../../../defaultFlow/tabs/payment/paymentTabSchema.js'

export default class PaymentTabDayTour extends PaymentTab {
  constructor (options) {
    super(options)
  }

  loadTab () {
    this.supportedCardTypes = this.booking.booking.creditCardTypes
    this.schemas = paymentTabSchema(this.config)
    this.schema = this.schemas.payment

    this.bookingType = this.user.role === 'travelAgent' ? 'TA' : 'CD'

    if (!this.billingAddress) {
      this.billingAddress = this.getBillingAddress()
    }

    this.showLoading()
    this.paymentOptions = new PaymentOptions({
      availablePaymentMethods: this.availablePaymentMethods,
      config: this.config,
      depositProminenceEnabled: this.config.features.mobileDepositProminenceEnabled,
      paymentTab: this,
      standardPriceStrikeThroughAllowed: this.config.features.standardPriceStrikeThroughAllowed,
    })

    const bookingInitialDate = new Date().getTime()
    this.autoCancelBookingInterval = setInterval(() => {
      const bookingCurrentDate = new Date()
      const autoCancelBookingDifference = (bookingCurrentDate.getTime() - bookingInitialDate) / 1000
      this.autoCancelBookingCountdown = this.autoCancelBookingTimeoutModal - Math.round(autoCancelBookingDifference)
      if (this.autoCancelBookingCountdown <= 0) {
        clearInterval(this.autoCancelBookingInterval)
        this.autoCancelBookingCountdown = 0
      }
      if (this.refresh) {
        this.refresh()
      }
    }, 1000)

    this.hideLoading()
    if (this.refresh) {
      this.refresh()
    }

    this.datadog.info('Payment tab loaded!')
  }
}
